(function($, exports) {

  function buildMap() {     
    var element = document.querySelector('.c-google-maps');
    var latitude = Number(element.dataset.lat);
    var longitude = Number(element.dataset.lng);
    var map = new google.maps.Map(element, {
      center: {
          lat: latitude,
          lng: longitude
        },
      zoom: 16,
      styles: 
[
    {
        "featureType": "water",
        "stylers": [
            {
                "saturation": 43
            },
            {
                "lightness": -11
            },
            {
                "hue": "#0088ff"
            }
        ]
    },
    {
        "featureType": "road",
        "elementType": "geometry.fill",
        "stylers": [
            {
                "hue": "#ff0000"
            },
            {
                "saturation": -100
            },
            {
                "lightness": 99
            }
        ]
    },
    {
        "featureType": "road",
        "elementType": "geometry.stroke",
        "stylers": [
            {
                "color": "#808080"
            },
            {
                "lightness": 54
            }
        ]
    },
    {
        "featureType": "landscape.man_made",
        "elementType": "geometry.fill",
        "stylers": [
            {
                "color": "#ece2d9"
            }
        ]
    },
    {
        "featureType": "poi.park",
        "elementType": "geometry.fill",
        "stylers": [
            {
                "color": "#ccdca1"
            }
        ]
    },
    {
        "featureType": "road",
        "elementType": "labels.text.fill",
        "stylers": [
            {
                "color": "#767676"
            }
        ]
    },
    {
        "featureType": "road",
        "elementType": "labels.text.stroke",
        "stylers": [
            {
                "color": "#ffffff"
            }
        ]
    },
    {
        "featureType": "poi",
        "stylers": [
            {
                "visibility": "off"
            }
        ]
    },
    {
        "featureType": "landscape.natural",
        "elementType": "geometry.fill",
        "stylers": [
            {
                "visibility": "on"
            },
            {
                "color": "#b8cb93"
            }
        ]
    },
    {
        "featureType": "poi.park",
        "stylers": [
            {
                "visibility": "on"
            }
        ]
    },
    {
        "featureType": "poi.sports_complex",
        "stylers": [
            {
                "visibility": "on"
            }
        ]
    },
    {
        "featureType": "poi.medical",
        "stylers": [
            {
                "visibility": "on"
            }
        ]
    },
    {
        "featureType": "poi.business",
        "stylers": [
            {
                "visibility": "simplified"
            }
        ]
    }
]
    });   

    var marker = new google.maps.Marker({
        map: map,
        position: {
          lat: latitude,
          lng: longitude
        },
        icon: {
          url: templateUrl + '/images/marker.svg',
          scaledSize: new google.maps.Size(50, 70)
        }
    });
  } 

  exports.init = function() {
    var d = document;
    var file = d.createElement('script'), s = d.scripts[0];
    file.src = 'https://maps.googleapis.com/maps/api/js?key=AIzaSyCOzKrHFWoQcYRZk507uIcSuh3Gqw_WsX8';
    file.async = true;
    s.parentNode.insertBefore(file, s);

    file.addEventListener('load', function() {
      buildMap();
    });
  };
  
})(jQuery, this.GOOGLEMAPS = {});